var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-login',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"loginForm",staticClass:"pt-login__withData",attrs:{"loginForm":_vm.form,"element-loading-text":"加载中","on-login":_vm.onLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }